export default __webpack_public_path__ + "static/media/cit.bf86d036.jpg";